(function ($, Promise) {

    var jqxr;
    var monitors = [];

    // Constructor
    function VICCTests(myValue) {

      //  Make sure that websocket is supported by browser. If not, show message.
      this.supportsWebSockets = 'WebSocket' in window || 'MozWebSocket' in window;

      this.viccMap = new VICCMap();
      this.api = new VICCCloudAPI();

      console.log("myValue", myValue);

      $("#start-test-1").on("click", ($.proxy(function (e) {
        this.emptyResults();
        var lat = $(e.currentTarget).data('lat');
        var lng = $(e.currentTarget).data('lng');
        this.api.requestPreview(lat, lng).then($.proxy(this.updatePreviewImage, this));
        this.api.requestVisualization(lat, lng).then($.proxy(this.updateVisualizationImages, this));
      }, this)));

      $("#start-test-2").on("click", ($.proxy(function (e) {
        this.emptyResults();
        var locations = $(e.currentTarget).data('locations');
        $(locations).each($.proxy(function (i, n) {
          var lat = n.lat;
          var lng = n.lng;
          setTimeout($.proxy(function (lat, lng) {
            if (i === locations.length - 1) {
              this.api.requestVisualization(lat, lng).then($.proxy(this.updateVisualizationImages, this));
            } else {
              this.api.requestVisualization(lat, lng);
            }
          }, this, lat, lng), i * 20);
        }, this));
      }, this)));

      $("#start-test-3").on("click", ($.proxy(function (e) {

        this.emptyResults();

        jqxr = $.ajax({
          type: "POST",
          url: "/api/visualization/batch",
          data: {},
          dataType: 'json'
        }).done($.proxy(function () {
          $("#test-console").html(JSON.stringify(jqxr.responseJSON, null, 2));

          Promise.all([
            this.api.monitorImageCreationPromise(jqxr.responseJSON.wildfireUrl),
            this.api.monitorImageCreationPromise(jqxr.responseJSON.floodUrl),
            this.api.monitorImageCreationPromise(jqxr.responseJSON.smogUrl),
          ]).then($.proxy(function () {
            this.updateVisualizationImages(jqxr.responseJSON);
          }, this));

        }, this)).fail($.proxy(function (err) {
          console.error(err)
        }, this));

      }, this)));

      $("#start-test-4").on("click", ($.proxy(function (e) {
        this.emptyResults();
        var lat = $("#field-lat").val();
        var lng = $("#field-lng").val();
        this.api.requestVisualization(lat, lng).then($.proxy(this.updateVisualizationImages, this));
      }, this)));

      $("#start-test-map").on("click", ($.proxy(function (e) {
        this.emptyResults();
        var lat = this.viccMap.lat;
        var lng = this.viccMap.lng;
        this.api.requestVisualization(lat, lng).then($.proxy(this.updateVisualizationImages, this));
      }, this)));
    }

    VICCTests.prototype.emptyResults = function () {
      // Remove current images
      $(".test-result .inner-wrapper").empty();
    }

    VICCTests.prototype.updatePreviewImage = function (responseJSON) {

      if (responseJSON.hasImagery == false) {
        alert("No imagery available from Google Street View.")
        return;
      }

      // Add original image
      $("#test-results-original .inner-wrapper").append("<a href='" + responseJSON.originalUrl + "' target='_blank'><img src='" + responseJSON.originalUrl + "'/></a>");
    }

    VICCTests.prototype.updateVisualizationImages = function (responseJSON) {

      if (responseJSON.hasImagery == false) {
        alert("No imagery available from Google Street View.")
        return;
      }

      // Add original image
      $("#test-results-original .inner-wrapper").append("<a href='" + responseJSON.originalUrl + "' target='_blank'><img src='" + responseJSON.originalUrl + "'/></a>");

      // Add fire AI image
      $("#test-results-fire .inner-wrapper").append("<a href='" + responseJSON.wildfireUrl + "' target='_blank'><img src='" + responseJSON.wildfireUrl + "'/></a>");

      // Add flood AI image
      $("#test-results-flood .inner-wrapper").append("<a href='" + responseJSON.floodUrl + "' target='_blank'><img src='" + responseJSON.floodUrl + "'/></a>");

      // Add smog AI image
      $("#test-results-smog .inner-wrapper").append("<a href='" + responseJSON.smogUrl + "' target='_blank'><img src='" + responseJSON.smogUrl + "'/></a>");
    }


    // Expose VICCTests
    window.VICCTests = VICCTests;

  }
)
(jQuery, Promise);
